export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["INACTIVE"] = "INACTIVE";
    AccountStatus["BLOCKED"] = "BLOCKED";
    AccountStatus["CLOSED"] = "CLOSED";
})(AccountStatus || (AccountStatus = {}));
export var CardType;
(function (CardType) {
    CardType["VIRTUAL"] = "VIRTUAL";
    CardType["PHYSICAL"] = "PHYSICAL";
})(CardType || (CardType = {}));
export var CardStatus;
(function (CardStatus) {
    CardStatus["ACTIVE"] = "ACTIVE";
    CardStatus["BLOCKED"] = "BLOCKED";
    CardStatus["EXPIRED"] = "EXPIRED";
    CardStatus["LOST"] = "LOST";
})(CardStatus || (CardStatus = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["DEPOSIT"] = "DEPOSIT";
    TransactionType["WITHDRAWAL"] = "WITHDRAWAL";
    TransactionType["AUTHORIZATION_PENDING"] = "AUTHORIZATION_PENDING";
    TransactionType["AUTHORIZATION_OPEN"] = "AUTHORIZATION_OPEN";
    TransactionType["AUTHORIZATION_DECLINED"] = "AUTHORIZATION_DECLINED";
    TransactionType["AUTHORIZATION_WITH_INFO"] = "AUTHORIZATION_WITH_INFO";
    TransactionType["SETTLEMENT"] = "SETTLEMENT";
    TransactionType["SETTLEMENT_WITH_AUTHORIZATION"] = "SETTLEMENT_WITH_AUTHORIZATION";
    TransactionType["REFUND"] = "REFUND";
    TransactionType["REFUND_DECLINED"] = "REFUND_DECLINED";
    TransactionType["REFUND_STOPPABLE"] = "REFUND_STOPPABLE";
    TransactionType["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    TransactionType["DIRECT_DEBIT_DECLINED"] = "DIRECT_DEBIT_DECLINED";
    TransactionType["DIRECT_DEBIT_PROCESSED"] = "DIRECT_DEBIT_PROCESSED";
    TransactionType["TOKEN_PROVISIONING"] = "TOKEN_PROVISIONING";
})(TransactionType || (TransactionType = {}));
export var BankTransactionKind;
(function (BankTransactionKind) {
    BankTransactionKind["TRANSFER"] = "TRANSFER";
    BankTransactionKind["STANDING_ORDER"] = "STANDING_ORDER";
    BankTransactionKind["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    BankTransactionKind["CARD_PAYMENT"] = "CARD_PAYMENT";
    BankTransactionKind["CASH_WITHDRAWAL"] = "CASH_WITHDRAWAL";
    BankTransactionKind["CASH_DEPOSIT"] = "CASH_DEPOSIT";
    BankTransactionKind["SALARY"] = "SALARY";
    BankTransactionKind["INTEREST"] = "INTEREST";
    BankTransactionKind["FEE"] = "FEE";
    BankTransactionKind["CREDIT"] = "CREDIT";
    BankTransactionKind["PAYMENT"] = "PAYMENT";
})(BankTransactionKind || (BankTransactionKind = {}));
export var CardOrderReason;
(function (CardOrderReason) {
    CardOrderReason["LOST"] = "LOST";
    CardOrderReason["DATA_CORRUPTION"] = "DATA_CORRUPTION";
    CardOrderReason["MISUSE"] = "MISUSE";
    CardOrderReason["DEFECT"] = "DEFECT";
    CardOrderReason["WITHDRAWN"] = "WITHDRAWN";
    CardOrderReason["EXPIRED"] = "EXPIRED";
    CardOrderReason["CARD_TYPE_CHANGE"] = "CARD_TYPE_CHANGE";
    CardOrderReason["NAME_CHANGE"] = "NAME_CHANGE";
})(CardOrderReason || (CardOrderReason = {}));
export var CardDeliveryMode;
(function (CardDeliveryMode) {
    CardDeliveryMode["TNT"] = "TNT";
    CardDeliveryMode["ENVELOPE"] = "ENVELOPE";
    CardDeliveryMode["EMPTY"] = "";
})(CardDeliveryMode || (CardDeliveryMode = {}));
export var CardOrderStatus;
(function (CardOrderStatus) {
    CardOrderStatus["PENDING"] = "PENDING";
    CardOrderStatus["PROCESSING"] = "PROCESSING";
    CardOrderStatus["COMPLETED"] = "COMPLETED";
    CardOrderStatus["FAILED"] = "FAILED";
    CardOrderStatus["CANCELLED"] = "CANCELLED";
})(CardOrderStatus || (CardOrderStatus = {}));
export var PayCenterHistoryAction;
(function (PayCenterHistoryAction) {
    PayCenterHistoryAction["CARD_REORDER_SUBMIT"] = "CARD_REORDER_SUBMIT";
    PayCenterHistoryAction["JOB_STATUS_POLL"] = "JOB_STATUS_POLL";
})(PayCenterHistoryAction || (PayCenterHistoryAction = {}));
export var BankTransactionLifecycleStage;
(function (BankTransactionLifecycleStage) {
    BankTransactionLifecycleStage["PENDING"] = "PENDING";
    BankTransactionLifecycleStage["SETTLED"] = "SETTLED";
})(BankTransactionLifecycleStage || (BankTransactionLifecycleStage = {}));
export var StandingOrderInterval;
(function (StandingOrderInterval) {
    StandingOrderInterval["DAILY"] = "DAILY";
    StandingOrderInterval["WEEKLY"] = "WEEKLY";
    StandingOrderInterval["MONTHLY"] = "MONTHLY";
    StandingOrderInterval["QUARTERLY"] = "QUARTERLY";
    StandingOrderInterval["YEARLY"] = "YEARLY";
})(StandingOrderInterval || (StandingOrderInterval = {}));
export var StandingOrderStatus;
(function (StandingOrderStatus) {
    StandingOrderStatus["PENDING"] = "PENDING";
    StandingOrderStatus["PROCESSING"] = "PROCESSING";
    StandingOrderStatus["ACTIVE"] = "ACTIVE";
    StandingOrderStatus["FAILED"] = "FAILED";
    StandingOrderStatus["CANCELLED"] = "CANCELLED";
})(StandingOrderStatus || (StandingOrderStatus = {}));
export var StandingOrderType;
(function (StandingOrderType) {
    StandingOrderType["REGULAR"] = "regular";
    StandingOrderType["SPARPLAN"] = "sparplan";
})(StandingOrderType || (StandingOrderType = {}));
export var BankingProcessorType;
(function (BankingProcessorType) {
    BankingProcessorType["PAYCENTER"] = "paycenter";
    BankingProcessorType["FINAPI"] = "finapi";
})(BankingProcessorType || (BankingProcessorType = {}));
export var PayCenterSubscriptionPlan;
(function (PayCenterSubscriptionPlan) {
    PayCenterSubscriptionPlan["FREE"] = "EXPLORER";
    PayCenterSubscriptionPlan["SMART"] = "BASIC";
})(PayCenterSubscriptionPlan || (PayCenterSubscriptionPlan = {}));
export var CardRenewalDraftStatus;
(function (CardRenewalDraftStatus) {
    CardRenewalDraftStatus["DRAFT"] = "DRAFT";
    CardRenewalDraftStatus["APPROVED"] = "APPROVED";
    CardRenewalDraftStatus["PROCESSING"] = "PROCESSING";
    CardRenewalDraftStatus["COMPLETED"] = "COMPLETED";
    CardRenewalDraftStatus["REJECTED"] = "REJECTED";
    CardRenewalDraftStatus["CANCELLED"] = "CANCELLED";
    CardRenewalDraftStatus["FAILED"] = "FAILED";
})(CardRenewalDraftStatus || (CardRenewalDraftStatus = {}));
//# sourceMappingURL=banking.types.js.map